export default "__VITE_ASSET__D7deax1h__"